import type { ChallengeCard as ChallengeCardType } from "@/pages/play/catalog";
import { KnightBadge } from "@/pages/play/KnightBadge";

type ChallengeCardProps = {
  card: ChallengeCardType;
  versionLabel: string;
  onOpen: (card: ChallengeCardType) => void;
};

export function ChallengeCard({ card, versionLabel, onOpen }: ChallengeCardProps) {
  return (
    <button
      className={`challenge-card challenge-card--${card.accent}`}
      type="button"
      onClick={() => onOpen(card)}
    >
      <span className="challenge-card__corner challenge-card__corner--top">
        {versionLabel}
      </span>
      <KnightBadge accent={card.accent} />
      <div className="challenge-card__body">
        <h3>{card.title}</h3>
      </div>
      <span className="challenge-card__corner challenge-card__corner--bottom">
        {versionLabel}
      </span>
    </button>
  );
}
